export const COMPONENT_DEFINITION_REF = 'COMPONENT_DEFINITION_REF';